module.exports = __webpack_public_path__ + "static/media/shop-all-kind-of-vintage-design-seating-online-at-zo-goed-als-oud.a175c717.jpg";